import color from './color';

export default function(context, item, opacity) {
  opacity *= (item.fillOpacity==null ? 1 : item.fillOpacity);
  if (opacity > 0) {
    context.globalAlpha = opacity;
    context.fillStyle = color(context, item, item.fill);
    return true;
  } else {
    return false;
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/util/canvas/fill.js
// module id = 273
// module chunks = 0